export type TIdentifierIds = 4 | 5 | 6;
export type TTypeIds = 1 | 2;
export type TGroupLoyaltyIds = 1 | 2 | 3;

export type TIdentifiers = 'DNI' | 'RUC' | 'PASAPORTE';
export type TTypes = 'PERSONA_NATURAL' | 'PERSONA_JURIDICA';
export type TGroupLoyaltys = 'BAJA' | 'MEDIA' | 'ALTA';

export interface DocumentType {
  id: TIdentifierIds;
  name: TIdentifiers;
}
export interface DocumentTypeType {
  id: TTypeIds;
  name: TTypes;
}
export interface DocumentTypeGroupLoyalty {
  id: TGroupLoyaltyIds;
  name: TGroupLoyaltys;
}

export const IdentifierTypeDocument: DocumentType[] = [
  { id: 4, name: 'DNI' },
  { id: 5, name: 'RUC' },
  { id: 6, name: 'PASAPORTE' }
];
export const TypeTypeDocument: DocumentTypeType[] = [
  { id: 1, name: 'PERSONA_NATURAL' },
  { id: 2, name: 'PERSONA_JURIDICA' }
];
export const GroupLoyaltyTypeDocument: DocumentTypeGroupLoyalty[] = [
  { id: 1, name: 'BAJA' },
  { id: 2, name: 'MEDIA' },
  { id: 3, name: 'ALTA' }
];

export const IDENTIFIER_ID = {
  4: 'DNI',
  5: 'RUC',
  6: 'PASAPORTE'
};
export const TYPE_ID = {
  1: 'PERSONA_NATURAL',
  2: 'PERSONA_JURIDICA'
};
export const GROUPLOYALTY_ID = {
  1: 'BAJA',
  2: 'MEDIA',
  3: 'ALTA'
};
